import { render, staticRenderFns } from "./Comparativas.vue?vue&type=template&id=623bb6cc&"
import script from "./Comparativas.vue?vue&type=script&lang=js&"
export * from "./Comparativas.vue?vue&type=script&lang=js&"
import style0 from "./Comparativas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports